/* istanbul ignore file */
import dynamic from 'next/dynamic';

import { ContentBlockRenderer } from 'src/types/Block';
import { ContentstackSection } from 'src/types/Contentstack';
import { Transformer } from 'src/types/Transformer';

export const renderer: ContentBlockRenderer<Record<string, never>, Record<string, never>> = {
  Component: dynamic(() =>
    import('src/components/blocks/PreviewErrorBlock').then((mod) => mod.PreviewErrorBlock),
  ),
  getProps: () => ({}),
};

export const createPreviewErrorTransformer = (errorMessage: string) => {
  const previewErrorTransformer: Transformer<
    ContentstackSection,
    Record<string, never>,
    Record<string, never>
  > = ({ _metadata }) => ({
    uid: _metadata.uid,
    renderer,
    serializedData: {},
    errors: [{ message: errorMessage }],
  });

  return previewErrorTransformer;
};
